import * as actions from './actions'
import {
  addProduct,
  getCartForDate,
  removeAllProducts,
  removeProduct
} from '../../api/sduiService'
import { mapProductProps } from './utils'
import * as orderActions from '../order/actions'

export const fetchCartForDate = date => dispatch => {
  dispatch(actions.fetchCartForDate({ date }))
  getCartForDate(date)
    .then(res => res.json())
    .then(({ data }) => {
      dispatch(
        actions.fetchCartForDateSucceed({
          date,
          cart: data?.products.map(mapProductProps)
        })
      )
    })
    .catch(() => {
      dispatch(actions.fetchCartForDateFailed())
    })
}

export const addProductToCart = (date, product, quantity) => dispatch => {
  dispatch(actions.addProductToCart())
  addProduct(date, product.inventoryId, quantity, product.id)
    .then(res => res.json())
    .then(res => {
      const productInCart = res?.items?.find(
        p => p.inventoryId === product.inventoryId
      )
      dispatch(
        actions.addProductToCartSucceed({
          date,
          product: { ...product, ...productInCart }
        })
      )
      // to sync menu cart
      dispatch(orderActions.addProduct({ product, quantity }))
    })
    .catch(() => {
      dispatch(actions.addProductToCartFailed())
    })
}

export const removeProductFromCart = (date, product) => dispatch => {
  dispatch(actions.removeProductFromCart())
  removeProduct(date, product.inventoryId, product.id)
    .then(res => res.json())
    .then(res => {
      const productInCart = res?.items?.find(
        p => p.inventoryId === product.inventoryId
      )
      dispatch(
        actions.removeProductFromCartSucceed({
          date,
          product: productInCart,
          inventoryId: product.inventoryId
        })
      )
      // to sync menu cart
      dispatch(orderActions.removeProduct({ product, quantity: 1 }))
    })
    .catch(() => {
      dispatch(actions.removeProductFromCartFailed())
    })
}

export const clearCart = date => dispatch => {
  dispatch(actions.clearCart())
  removeAllProducts(date)
    .then(() => {
      dispatch(
        actions.clearCartSucceed({
          date
        })
      )
      // to sync menu cart
      dispatch(orderActions.clearOrder())
    })
    .catch(() => {
      dispatch(actions.clearCartFailed())
    })
}
